'use client';
import React from 'react';

import { IRepositoryCompareEntry } from '@/lib/repositoryCompareApi';
import { Row } from '@/ui/primatives';
import Tag from '@/ui/Tag';
import pluralize from 'pluralize';

const AddTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tag pill small variant="success">
    {children}
  </Tag>
);

const RemoveTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tag pill small variant="error">
    {children}
  </Tag>
);

const ModifyTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tag pill small variant="info">
    {children}
  </Tag>
);

const FileChangeCountTags: React.FC<{ entry: IRepositoryCompareEntry }> = ({ entry }) => {
  const summary = entry.diff_summary;
  // get the total of the values for each key of file_counts key value pairs
  const totalFileChanges = Object.values(summary?.dir?.file_counts || {}).reduce((a, b) => a + b, 0);

  const hasChanges = summary?.dir && totalFileChanges;
  if (!hasChanges) {
    return null;
  }

  const { added, removed, modified } = summary?.dir?.file_counts || {};
  return (
    <div>
      <Row gap={5} alignItems="center">
        {!!added && (
          <AddTag>
            +{added} {pluralize('file', added, false)}
          </AddTag>
        )}
        {!!removed && (
          <RemoveTag>
            -{removed} {pluralize('file', removed, false)}
          </RemoveTag>
        )}
        {!!modified && (
          <ModifyTag>
            Δ{modified} {pluralize('file', modified, false)}
          </ModifyTag>
        )}
      </Row>
    </div>
  );
};

export default FileChangeCountTags;
